// Unknown User for Comments
export const UNKNOWN_USER_AVATAR = 'https://cdn.auth0.com/avatars/un.png';
export const UNKNOWN_USER_NAME = 'Unknown User';

export const MIN_EMPTY_PIPE_DURATION_IN_SECONDS = 5 * 60; // 5min
export const MIN_AUGER_DURATION_IN_SECONDS = 12 * 60 * 60; // 12 hrs
export const MIN_DEVICE_OFFLINE_DURATION_IN_SECONDS = 20 * 60; // 20min

// Notification Tier Constants
export const NO_NOTIFICATIONS_TIER_NAME = 'No Notifications';
